import i18n from '../../managers/i18n'

i18n.register(
  'en-US',
  {
    increase: 'Increase by {value}',
    decrease: 'Decrease by {value}'
  },
  {
    ns: 'numberinput'
  }
)
